<template>
  <div :class="['container', { h5_funnel: isNewFunnel }, `${page_style || ''}`]">
    <template v-if="!isNewFunnel">
      <div class="upload-wraper" @click="goUpload">
        <div>{{ formItem.title }}</div>
        <div :class="classObj">
          <span>{{ formItem.photo_tip }}</span>
          <span class="info-arrow" v-show="!seted_color"></span>
        </div>
      </div>
      <p
        :class="['status-tip', 'tip_' + formItem.field_status]"
        v-show="formItem.field_result"
      >
        {{ formItem.field_result }}
      </p>
    </template>
    <template v-else>
      <div class="audit-wraper" @click="goUpload">
        <div class="icon-wrapper">
          <img-v3
            class="doc-icon"
            :src="doc_icon_url"
            alt=""
          />
        </div>
        <div class="info-status">
          <h5 class="info">{{ formItem.title }}</h5>
          <p :class="['status', `result_test_${formItem.field_status}`]">
            {{ formItem.desc_replace_field_result ? formItem.desc : formItem.field_result }}
          </p>
        </div>
        <div :class="classObj">
          <span>{{ formItem.photo_tip }}</span>
          <span class="info-arrow" v-show="!seted_color"></span>
        </div>
      </div>
    </template>
    <pop-alert v-if="isFleetFunnel" ref="popAlert" :alertInfo="alertInfo" :page_style="page_style"></pop-alert>
    <audit-dialog
      v-if="isFleetPCFunnel"
      ref="auditDialog"
      :form-item="formItem"
      :idx="idx"
      :is_finished="is_finished"
      :is_ocr="is_ocr"
      :page_type="page_type"
      :page_style="page_style"
      :can-upload="canUpload">
    </audit-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { showAlertDialog, showLoadingToast } from "../../tools/Tip";
import { post } from "../../tools/request";
import defaultImg from "../../images/icon_document_default.png";
import uploadedImg from "../../images/icon_document_uploaded.png";
import approvedImg from "../../images/icon_document_approved.png";
import blockedImg from "../../images/icon_document_blocked.png";
import { SUPPORT_COUNTRY as sc, SUPPORT_COUNTRY_CONFIG } from "../../tools/constant";
import PopAlert from "./pop-alert.vue"
import AuditDialog from "../baseAudit/audit-dialog.vue"

//上传入口会进入不同国家，所以跳转路由需要动态判断
export default {
  components: {
    PopAlert,
    AuditDialog
  },
  props: ["formItem", "idx", "is_ocr", "page_style", "canUpload", "omegaItem", "is_finished", "page_type", "onboarding_driver_id", "product"],
  computed: {
    ...mapState(["_ticket"]),
    params() {
      return new URLSearchParams(location.search);
    },
    isPreviewPage() {
      // 是预览页面
      return this.params.get('ob_page_type') === 'preview';
    },
    country() {
      //notes set default country
      let c = this.params.get("location_country");
      return sc[c] || "Mx";
    },
    inApp() {
      return !!Fusion.pickImage;
    },
    isNewFunnel() {
      return ["h5_funnel", "h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isFleetFunnel() {
      return ["h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    seted_color() {
      return this.formItem.type == "color" && this.formItem.field_status == 4;
    },
    is_audit() {
      return this.is_ocr || this.isNewFunnel;
    },
    classObj() {
      return {
        is_new_funnel: this.isNewFunnel,
        uploadTip: 1,
        ocr: this.is_audit,
        global_ocr: this.country !== "Br" && this.is_audit,
        ing: this.is_audit && this.formItem.field_status == 3,
        success: this.is_audit && this.formItem.field_status == 4,
        failed: this.is_audit && this.formItem.field_status == 5,
      };
    },
    doc_icon_url() {
      let imgMap = {
        0: defaultImg,
        1: defaultImg,
        2: defaultImg,
        3: uploadedImg,
        4: approvedImg,
        5: blockedImg,
      };
      return imgMap[this.formItem.field_status] || defaultImg;
    },
    jump_third_url() {
      return this.formItem.url || this.jumpUrl || ''
    }
  },
  data() {
    return {
      jumpUrl: '',
      alertInfo: {}
    };
  },
  mounted(){
    if (this.formItem.type === 'bank-card-99' && !this.isPreviewPage) {
      this.getBank99();
    }
  },
  methods: {
    goUpload() {
      if (this.isNewFunnel && !this.isPreviewPage) {
          // 基础信息状态为3审核中以及4完成时,不可点击
          // this.canUpload -----> 非基础信息上传外的其他证件是否可上传
          // 基础信息和其他证件的是否可上传是互斥的
          if (this.formItem.type === 'basic_info' && this.canUpload) {
            try {
              Omega.trackEvent("ibt_gd_inf_after_popups_num_sw", "", {
                ...this.omegaItem,
                page: this.isNewFunnel ? 1 : 0,
              });
            } catch (error) { }
            if (this.isFleetFunnel) {
              this.alertInfo = {
                desc: this.$t('GDriver_Optimization_Basic_information_RIPb'),
              }
              if (this.isFleetPCFunnel) {
                this.$message({
                  showClose: true,
                  message: this.alertInfo.desc,
                  duration: 0,
                  customClass: 'pc-message-wrapper',
                  iconClass: 'message-icon-info'
                });
              } else {
                this.$refs.popAlert.popShow = true;
              }
            } else {
              showAlertDialog(this, this.$t("GDriver_Optimization_Basic_information_RIPb"))
            }
            return
          }
          // 基础信息没完成前不可以上传证件
          if (!this.canUpload && this.formItem.type !== 'basic_info') {
            try {
              Omega.trackEvent("ibt_gd_inf_before_popups_num_sw", "", {
                ...this.omegaItem,
              });
            } catch (error) { }
            if (this.isFleetFunnel) {
              this.alertInfo = {
                title: this.$t('Fleet_optimizaton__CNVY'),
                desc: this.$t('Fleet_optimizaton__pPtD'),
                btn: this.$t('Fleet_optimizaton__GTUC')
              }
              this.$refs.popAlert.popShow = true;
              // this.$message({
              //   showClose: true,
              //   message: '这是一条消息提示',
              //   duration: 0,
              //   customClass: 'pc-message-wrapper',
              //   iconClass: 'message-icon-info'
              // });
            } else {
              showAlertDialog(this, this.$t("GDriver_Optimization_Fill_in_bcSG"))
            }
            return
          }
      }

      // phtoto -->> uploadXX,multi-photo-->multi-uploadXx,declare-->declareXX,linkage-photo--> linkage-uploadXX
      let rou = {
        portrait: `uploadCut`,
        photo: `upload${this.country}`,
        declare: `declare${this.country}`,
        "linkage-photo": `linkageUpload${this.country}`,
        "link-photo": `linkUpload`,
        "multi-photo": `multiUpload${this.country}`,
        "multi-declare": `multiDeclare`,
        color: `setColor${this.country}`,
        introduce: `introduce${this.country}`,
        "select-photo": `selectPhoto${this.country}`,
        "inner-input": `detailMultiUpload`,
        "in_select_photo": `detailMultiUpload`,
        photo_new: `uploadNew`,
        photo_simplify: `uploadSimple`,
        basic_info: `baseInfo${this.country}`, // 基础信息作为证件的一项,点击跳转至原有的基础信息页面
        avatar_new: `avatarNew`
      }[this.formItem.type];
      if (this.seted_color) {
        return;
      }
      if (this.jump_third_url) {
        window.location.href = this.jump_third_url;
        return;
      }
      if (this.isFleetPCFunnel && this.formItem.type !== 'basic_info') {
        this.$refs.auditDialog.dialogShow = true;
      } else {
        if (this.formItem.type === 'avatar_new') {
          this.$router.push({
            name: rou,
            params: {
              configs: this.formItem,
              onboarding_driver_id: this.onboarding_driver_id,
              product: this.product,
              base_url: process.env.BASE_URL,
              upload_base_url: process.env.UPLOAD_BASE_URL,
              page_source: 'register',
              _ticket: this._ticket || '',
              onSubmit: () => {
                this.$router.replace({ name: "home" });
              }
            },
          });
        } else {
          this.$router.push({
            name: rou,
            params: {
              configs: this.formItem,
              page_style: this.page_style
            },
          });
        }
      }
      try {
        Omega.trackEvent("ibt_gd_upload_options_ck", "", {
          ...this.omegaItem,
          doc: this.formItem.key
        });
      } catch (error) { }
    },
    getBank99() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      let ticket = this._ticket || up.get("ticket") || up.get("token");
      let lang = up.get("lang"),
        l = up.get("location_country"),
        utc_offset = up.get("utc_offset");
      lang = SUPPORT_COUNTRY_CONFIG[l]["lang"];
      let href = location.href.replace(/\#.*/g, "");
      let redirect = encodeURIComponent(href);
      // this.jumpUrl  = `https://page.99taxis.mobi/pay_intl_driver/card99_progress_v2/card99_progress_v2.html?redirect=${redirect}&ticket=${ticket}&lang=${lang}&utc_offset=${utc_offset}&entrytype=1`;
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // post(process.env.GET_BANKINFO_BR, up)
      //   .then(data => {
      //     let defaultPayMethod = data.defaultPayMethod;
      //     if (defaultPayMethod.bankInfo) {
      //       this.jumpUrl = `https://page.99taxis.mobi/pay_intl_driver/bank_account/bank_account.html?redirect=${redirect}&ticket=${ticket}&lang=${lang}&utc_offset=${utc_offset}&entrytype=1`;
      //     }
      //   })
      //   .catch(err => {
      //     showAlertDialog(this);
      //   })
      //   .finally(() => {
      //     this.toast.hide();
      //   });
      // 之前的是否绑卡逻辑移到后端去了, 跳转链接由后端控制
      post(process.env.GET_BANKINFO_BR, up)
        .then(data => {
          let l = data.jump_link;
          let query = `redirect=${redirect}&ticket=${ticket}&lang=${lang}&utc_offset=${utc_offset}&entrytype=1&show_apply_card=true`
          if (l.indexOf("?") > -1) {
            l = `${l}&${query}`;
          } else {
            l = `${l}?${query}`;
          }
          this.jumpUrl = l;
        })
        .catch(err => {
          showAlertDialog(this, err.errmsg);
        })
        .finally(() => {
          this.toast.hide();
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-right: 0.36rem;
  margin-bottom: 0.1rem;
  font-size: 0.36rem;
  color: #414141;
  background: #fff;
  &.h5_funnel {
    height: 1.76rem;
    position: relative;
    padding: 0;
    margin: 0 0.32rem;
    display: inherit;
    // display: flex;
    // flex-direction: row;
    // align-items: center;
    // justify-content: normal;
    border-bottom: 1px solid #eeeeee;
    .audit-wraper {
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: normal;
      .icon-wrapper {
        flex-shrink: 0;
      }
      .info-status {
        padding-right: 0.2rem;
      }
    }
  }
}
.status-tip {
  width: 7.1rem; //铺满右侧
  margin-right: 0;
}
.upload-wraper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 1.4rem;
}
.uploadTip {
  display: flex;
  align-items: center;
  font-size: 0.28rem;
  color: #666;
  &.is_new_funnel {
    position: absolute;
    right: 0;
    .info-arrow {
      border-right: 2px solid #999999;
      border-bottom: 2px solid #999999;
    }
  }
}
.ocr {
  color: #2697ff;
  .info-arrow {
    border-right: 2px solid #2697ff;
    border-bottom: 2px solid #2697ff;
  }
}
.global_ocr {
  color: #ff7226;
  .info-arrow {
    border-right: 2px solid #ff7226;
    border-bottom: 2px solid #ff7226;
  }
}
.ing {
  color: #91a0b4;
  .info-arrow {
    border-right: 2px solid #91a0b4;
    border-bottom: 2px solid #91a0b4;
  }
}
.success {
  color: #18c47c;
  .info-arrow {
    border-right: 2px solid #18c47c;
    border-bottom: 2px solid #18c47c;
  }
}
.failed {
  color: #f86767;
  .info-arrow {
    border-right: 2px solid #f86767;
    border-bottom: 2px solid #f86767;
  }
}
.icon-wrapper {
  width: 0.96rem;
  height: 0.96rem;
  margin-right: 0.24rem;
  .doc-icon {
    width: 100%;
    height: 100%;
  }
}
.info-status {
  .info {
    margin-bottom: 0.1rem;
    line-height: 0.48rem;
    font-size: 0.32rem;
    color: #333333;
    font-weight: 700;
  }
  .status {
    font-size: 0.28rem;
    color: #999999;
    line-height: 0.32rem;
    font-weight: 500;
    &.result_test_0,
    &.result_test_1,
    &.result_test_2 {
      color: #999999;
    }
    &.result_test_3 {
      color: #2697ff;
    }
    &.result_test_4 {
      color: #00CCAA;
    }
    &.result_test_5 {
      color: #F86767;
    }
  }
}

.container.h5_funnel_fleet_pc {
  height: 88px;
  margin: 0 32px;
  .icon-wrapper {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }
  .info-status {
    .info {
      margin-bottom: 5px;
      line-height: 19px;
      font-size: 16px;
      color: #333333;
    }
    .status {
      font-size: 14px;
      line-height: 16px;
    }
  }
  .info-arrow {
    width: 7px;
    height: 7px;
  }
}

</style>

